import { createSlice } from "@reduxjs/toolkit";
import {
	LicenceInfoObject,
	ProductBasketObject,
	RxShoppingCartObject,
} from "../../pages/sale/SalePage";

export const cartSlice = createSlice({
	name: "cart",
	initialState: {
		cartItem: {
			id: 0,
			installment: false,
			products: [] as ProductBasketObject[],
			licences: [] as LicenceInfoObject[],
			oldDistributor: undefined,
			distributor: undefined,
			totalDiscount: 0,
			totalPrice: 0,
			totalPriceWithKdv: 0,
		} as RxShoppingCartObject,
	},
	reducers: {
		setCart: (state, action) => {
			state.cartItem = action.payload.cartItem as RxShoppingCartObject;
		},
	},
});

export const { setCart } = cartSlice.actions;
